export class ClassificationDoesNotExists extends Error { }
export class EmptyFeatureValue extends Error { }
export class FeatureDoesNotExists extends Error { }
export class NoActiveClassification extends Error { }
export class NoActiveFeature extends Error { }